import { createStyles } from "@mantine/emotion";

export default createStyles ( () => {

	return {
		videoEmptyView: {
			aspectRatio     : "16/9",
			display         : "flex",
			width           : "100%",
			height          : "100%",
			justifyContent  : "center",
			alignItems      : "center",
			flexDirection   : "column",
			color           : "#fff",
			backgroundColor : "#000"
		},
		header: {
			padding    : "10px",
			fontSize   : "18px",
			fontWeight : "500"
		},
		subHeader: {
			display   : "flex",
			padding   : "10px",
			textAlign : "center"
		},
		subHeaderChild: {
			marginLeft: "5px"
		}
	};
} );
